import { useT } from '../i18n/LangContext';

export default function LangPicker() {
  const { showPicker, setLang, t } = useT();
  if (!showPicker) return null;

  const options = [
    { code: 'en', badge: 'E', label: 'English' },
    { code: 'de', badge: 'G', label: 'Deutsch' },
  ];

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 99999,
      background: 'rgba(0,0,0,0.25)', backdropFilter: 'blur(6px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      <div style={{
        background: '#ffffff',
        border: '1px solid #e2e8f0',
        borderRadius: 16,
        padding: '40px 36px',
        textAlign: 'center',
        maxWidth: 380,
        width: '90%',
        boxShadow: '0 12px 48px rgba(0,0,0,0.12)',
        fontFamily: 'Arial, sans-serif',
      }}>
        <div style={{ fontSize: 28, marginBottom: 6 }}>LANG</div>
        <h2 style={{ color: '#0f172a', fontFamily: 'Arial, sans-serif', fontWeight: 900, fontSize: 22, margin: '0 0 4px' }}>
          {t('langPickerTitle')}
        </h2>
        <p style={{ color: '#64748b', fontSize: 14, margin: '0 0 28px', fontFamily: 'Arial, sans-serif' }}>
          {t('langPickerSubtitle')}
        </p>
        <div style={{ display: 'flex', gap: 12 }}>
          {options.map(({ code, badge, label }) => (
            <button
              key={code}
              onClick={() => setLang(code)}
              style={{
                flex: 1,
                padding: '14px 0',
                borderRadius: 12,
                border: '1px solid #e2e8f0',
                background: '#f8fafc',
                color: '#0f172a',
                cursor: 'pointer',
                fontFamily: 'Arial, sans-serif',
                fontSize: 15,
                fontWeight: 700,
                transition: 'all .2s',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 10,
              }}
              onMouseEnter={(e) => { e.currentTarget.style.borderColor = '#4F46E5'; e.currentTarget.style.background = 'rgba(79,70,229,0.06)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.borderColor = '#e2e8f0'; e.currentTarget.style.background = '#f8fafc'; }}
            >
              <span style={{
                width: 22,
                height: 22,
                borderRadius: 999,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: '#eef2ff',
                color: '#4F46E5',
                fontSize: 12,
                fontWeight: 900,
              }}>{badge}</span>
              <span>{label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

